export default new class login {
  constructor() {
    this.loginFormSelector = '_login__form';
    this.submitBtnSelector = '_login__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'tooltip__success';
    this.successVisibleSelector = 'visible';
    this.preLoaderSelector = 'login__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.loginFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();

      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    $(form)
      .request('Login::onAjax', {
        complete: (res) => {
          this.showTooltip(res);
        },
      });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('error');
    } else {
      tooltip.classList.remove('error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
